import { z } from "zod";
import { createTRPCRouter, protectedProcedure } from "../trpc";
import { TRANSACTION_TYPE } from "@prisma/client";
import { sortByNepaliDate } from "../utils";

export const incomeRouter = createTRPCRouter({
    getIncomeTable: protectedProcedure
        .query(async ({ ctx }) => {
            const response = await ctx.prisma.transaction.findMany({
                where: {
                    type: TRANSACTION_TYPE.INCOME,
                    isActive: true
                },
                include: {
                    income: {
                        select: { id: true }
                    }
                }
            });

            const sortedResponse = response.sort(sortByNepaliDate);
            const incomes = sortedResponse.map((txn) => ({
                id: txn.income?.id,
                ...txn,
                income: undefined
            }));

            return incomes;
        }),

    // getIncomeById: publicProcedure
    //     .input(z.object({
    //         id: z.number()
    //     }))
    //     .query(async ({ ctx, input }) => {
    //         const income = await ctx.prisma.transaction.findUnique({
    //             where: {
    //                 id: input.id,
    //                 type: TRANSACTION_TYPE.INCOME
    //             }
    //         });
    //
    //         return income;
    //     }),

    createIncome: protectedProcedure
        .input(
            z.object({
                day: z.coerce.number().nullable(),
                month: z.string().min(1, "Month is required"),
                year: z.coerce.number().min(1, "Year is required"),
                billNo: z.string().nullable(),
                purpose: z.string().min(1, "Purpose is required"),
                method: z.string().min(1, "Method is required"),
                amount: z.coerce.number().min(1, "Amount is required"),
                remark: z.string().optional(),
            })
        )
        .mutation(async ({ ctx, input }) => {
            const newIncome = await ctx.prisma.transaction.create({
                data: {
                    ...input,
                    type: TRANSACTION_TYPE.INCOME,
                    isActive: true,
                    income: {
                        create: {}
                    }
                }
            });

            return newIncome;
        }),

    updateIncomeTable: protectedProcedure
        .input(
            z.object({
                transactionId: z.number(),
                day: z.coerce.number().nullable(),
                month: z.string().min(1, "Month is required"),
                year: z.coerce.number().min(1, "Year is required"),
                billNo: z.string().nullable(),
                purpose: z.string().min(1, "Purpose is required"),
                method: z.string().min(1, "Method is required"),
                amount: z.coerce.number().min(1, "Amount is required"),
                remark: z.string().optional(),
            })
        )
        .mutation(async ({ ctx, input }) => {
            const { transactionId, ...data } = input;

            const updatedIncome = await ctx.prisma.transaction.update({
                where: {
                    transactionId,
                    type: TRANSACTION_TYPE.INCOME
                },
                data
            });

            return updatedIncome;
        }),

    // IF THERE WILL BE NEED FOR THE DELETION
    // WE WILL BE WORKING WITH SOFT DELETE

    // deactivateIncome: publicProcedure
    //   .input(z.object({
    //     id: z.number()
    //   }))
    //   .mutation(async ({ ctx, input }) => {
    //     const deactivatedIncome = await ctx.prisma.transaction.update({
    //       where: {
    //         id: input.id,
    //         type: TRANSACTION_TYPE.INCOME
    //       },
    //       data: {
    //         isActive: false
    //       }
    //     });
    //     
    //     return deactivatedIncome;
    //   }),

    // reactivateIncome: publicProcedure
    //   .input(z.object({
    //     id: z.number()
    //   }))
    //   .mutation(async ({ ctx, input }) => {
    //     const reactivatedIncome = await ctx.prisma.transaction.update({
    //       where: {
    //         id: input.id,
    //         type: TRANSACTION_TYPE.INCOME
    //       },
    //       data: {
    //         isActive: true
    //       }
    //     });
    //     
    //     return reactivatedIncome;
    //   }),
});
